import { useState, useEffect } from 'react'
import { useRxDB } from 'rxdb-hooks'
import { LoadOptions, OxomiData, OxomiMetaData, OxomiOptions } from '@obeta/models/lib/models/Oxomi'
import { RxLocalDocumentData } from 'rxdb/dist/types/types'
import {
  buildOxomiData,
  getOxomiProductData,
  normalizeSupplierIdForOxomi,
  getCompatibleOxomiTokenAndPortal,
} from './oxomiDataUtils'
import { of, switchMap } from 'rxjs'
export * from '@obeta/models/lib/models/Oxomi'

const INITIAL_OXOMI_DATA = {
  oxomiAttachments: [],
  oxomiImages: [],
  oxomiPages: [],
  oxomiVideos: [],
  oxomi3DImages: [],
}

export const useOxomiData = (oxomi: OxomiOptions | null, options: LoadOptions = {}) => {
  const {
    images = true,
    video = true,
    pages = true,
    attachments = true,
    threeDImages = false,
  } = options

  const db = useRxDB()
  const [oxomiData, setOxomiData] = useState<OxomiData>(INITIAL_OXOMI_DATA)

  useEffect(() => {
    const sub = getCompatibleOxomiTokenAndPortal({
      db,
      portal: oxomi?.portal,
      accessToken: oxomi?.accessToken,
    })
      .pipe(
        switchMap((oxomiMetaData: RxLocalDocumentData<OxomiMetaData>) => {
          if (!oxomi?.supplierId || !oxomi?.oxomiId) return of(null)

          return getOxomiProductData({
            supplierNumber: normalizeSupplierIdForOxomi(oxomi.supplierId),
            accessToken: oxomiMetaData.data.token,
            portal: oxomiMetaData.data.portal,
            itemNumber: oxomi.oxomiId,
            images: true,
            videos: true,
            pages: true,
            attachments: true,
          })
        })
      )
      .subscribe(async (response) => {
        if (!response) return

        const productData = response.data.products[0].queries

        const newData = await buildOxomiData({
          productData,
          supplierId: oxomi?.supplierId,
          oxomiId: oxomi?.oxomiId,
          threeDImages,
        })

        setOxomiData(newData)
      })

    return () => {
      sub.unsubscribe()
    }
  }, [
    oxomi?.oxomiId,
    oxomi?.supplierId,
    oxomi?.accessToken,
    oxomi?.portal,
    threeDImages,
    images,
    video,
    pages,
    attachments,
    db,
  ])

  return oxomiData
}
